var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlur(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 19.65C5.25 20.1471 4.84706 20.55 4.35 20.55C3.85294 20.55 3.45 20.1471 3.45 19.65C3.45 19.1529 3.85294 18.75 4.35 18.75C4.84706 18.75 5.25 19.1529 5.25 19.65Z",
    stroke: "#070707",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 4.35C5.25 4.84706 4.84706 5.25 4.35 5.25C3.85294 5.25 3.45 4.84706 3.45 4.35C3.45 3.85294 3.85294 3.45 4.35 3.45C4.84706 3.45 5.25 3.85294 5.25 4.35Z",
    stroke: "#070707",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.35 4.35C13.35 5.09558 12.7456 5.7 12 5.7C11.2544 5.7 10.65 5.09558 10.65 4.35C10.65 3.60442 11.2544 3 12 3C12.7456 3 13.35 3.60442 13.35 4.35Z",
    stroke: "#070707",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.55 4.35C20.55 4.84706 20.1471 5.25 19.65 5.25C19.1529 5.25 18.75 4.84706 18.75 4.35C18.75 3.85294 19.1529 3.45 19.65 3.45C20.1471 3.45 20.55 3.85294 20.55 4.35Z",
    stroke: "#070707",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.7 12C5.7 12.7456 5.09558 13.35 4.35 13.35C3.60442 13.35 3 12.7456 3 12C3 11.2544 3.60442 10.65 4.35 10.65C5.09558 10.65 5.7 11.2544 5.7 12Z",
    stroke: "#070707",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8 12C13.8 12.9941 12.9941 13.8 12 13.8C11.0059 13.8 10.2 12.9941 10.2 12C10.2 11.0059 11.0059 10.2 12 10.2C12.9941 10.2 13.8 11.0059 13.8 12Z",
    stroke: "#070707",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21 12C21 12.7456 20.3956 13.35 19.65 13.35C18.9044 13.35 18.3 12.7456 18.3 12C18.3 11.2544 18.9044 10.65 19.65 10.65C20.3956 10.65 21 11.2544 21 12Z",
    stroke: "#070707",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.35 19.65C13.35 20.3956 12.7456 21 12 21C11.2544 21 10.65 20.3956 10.65 19.65C10.65 18.9044 11.2544 18.3 12 18.3C12.7456 18.3 13.35 18.9044 13.35 19.65Z",
    stroke: "#070707",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.55 19.65C20.55 20.1471 20.1471 20.55 19.65 20.55C19.1529 20.55 18.75 20.1471 18.75 19.65C18.75 19.1529 19.1529 18.75 19.65 18.75C20.1471 18.75 20.55 19.1529 20.55 19.65Z",
    stroke: "#070707",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlur);
export default __webpack_public_path__ + "static/media/blur.f8db78a966b224c53f831d6d4dcc0dcc.svg";
export { ForwardRef as ReactComponent };